import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import About from '@/components/About'
import Products from '@/components/Products'
import Product from '@/components/Product'

import Locations from '@/components/Locations'
import Login from '@/components/Login'

import Buyer from '@/components/Buyer'

/*START USER*/
import User from '@/components/User'
import UserAccount from '@/components/UserAccount'
import Cart from '@/components/Cart' //tester
import UserSidebar from '@/components/UserSidebar'
/*END USER*/

import Supplier from '@/components/Supplier'
import AccountSelection from '@/components/AccountSelection'
import SupplierProductProposal from '@/components/SupplierProductProposal'
import SupplierSidebar from '@/components/SupplierSidebar'
import SupplierProducts from '@/components/SupplierProducts'
import SupplierProduct from '@/components/SupplierProduct'
import AdminSidebar from '@/components/AdminSidebar'
import AdminProposal from '@/components/AdminProposal'
import AdminPurchase from '@/components/AdminPurchase'
import AdminSuppliers from '@/components/AdminSuppliers'
import AdminSupplierItems from '@/components/AdminSupplierItems'
import AdminProducts from '@/components/AdminProducts'


import PageNotFound from '@/components/PageNotFound'

Vue.use(Router)

//Components go here



export default new Router({
  routes: [
    {
		path: '/',
		name: 'Home',
		component: Home
    },
    {
    	path: '/about',
    	name: 'About',
    	component: About
    },
    {
    	path: '/products',
    	name: 'Products',
    	component: Products
    },
    //product code
    {
        path: '/products/product/:productcode',
        name: 'Product',
        component: Product
    },

    {
    	path: '/locations',
    	name: 'Locations',
    	component: Locations
    },
    {
    	path: '/login',
    	name: 'Login',
    	component: Login
    },
    ///////// experiments 
    {
        path: '/registration/buyer',
        name: 'RegistrationBuyer',
        component: Buyer
    },
    {
        path: '/registration/supplier',
        name: 'RegistrationSupplier',
        component: Supplier
    },
    ///////// experiments
    {
        path: '/account-selection',
        name: 'AccountSelection',
        component: AccountSelection
    },
    //START of users ----------------------
    //purchases
    {
        path: '/user',
        name: 'User',
        components: {
            default: User,
            sidebar: UserSidebar
        }
    },
    //account information
    {
        path: '/useraccount',
        name: 'UserAccount',
        components: {
            default: UserAccount,
            sidebar: UserSidebar
        }
    },
    //cart
    {
        path: '/cart',
        name: 'UserCart',
        components: {
            default: Cart,
            sidebar: UserSidebar
        }
    },
    //cart
    //END of users ----------------------
    {
        path: '/supplierproductproposal',
        name: 'SupplierProductProposal',
        components: {
            default: SupplierProductProposal,
            sidebar: SupplierSidebar
        }
    },
    {
        path: '/supplierproducts',
        name: 'SupplierProducts',
        components: {
            default: SupplierProducts,
            sidebar: SupplierSidebar
        }
    },
    {
        //this is a test component to be merged later
        path: '/supplierproduct',
        name: 'SupplierProduct',
        components: {
            default: SupplierProduct,
            sidebar: SupplierSidebar
        }
    },
    {
        path: '/adminproposal',
        name: 'AdminProposal',
        components: {
            default: AdminProposal,
            sidebar: AdminSidebar
        }
    },
    {
        path: '/adminpurchase',
        name: 'AdminPurchase',
        components: {
            default: AdminPurchase,
            sidebar: AdminSidebar
        }
    },
    {
        path: '/adminsuppliers',
        name: 'AdminSuppliers',
        components: {
            default: AdminSuppliers,
            sidebar: AdminSidebar
        }
    },
    {
        path: '/adminsupplieritems',
        name: 'AdminSupplierItems',
        components: {
            default: AdminSupplierItems,
            sidebar: AdminSidebar
        }
    },
    {
        path: '/adminproducts',
        name: 'AdminProducts',
        components: {
            default: AdminProducts,
            sidebar: AdminSidebar 
        }
    },
    {
        path: "*", 
        name: '404',
        component: PageNotFound
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js